// extracted by mini-css-extract-plugin
export default {"Form":"caution_Form__cNUPG","Form__footer":"caution_Form__footer__5hVsP"};